/**
 * @dtsModule max.performance
 * @dtsNamespace performance
 * @dtsDesc performance
 */
export const performance = {
  /**
   * @dtsExport
   */
  beginSession(name?: string) {
    console.time(name)
    return name
  },
  /**
   * @dtsExport
   */
  endSession(id: string) {
    console.timeEnd(id)
  }
}